import {Injectable} from '@angular/core';
import {ModalController} from '@ionic/angular';
import {AuthService} from './auth.service';
import {AuthStorageService} from '../storage/auth-storage.service';
import {UserService} from '../customer/user.service';
import {AddressService} from '../customer/address.service';
import {ProfileCompletionModalPage} from '../../modals/profile-completion-modal/profile-completion-modal.page';

@Injectable({
  providedIn: 'root'
})
export class ProfileCompletionService {

  private checking = false;

  constructor(
    private authService: AuthService,
    private authStorageService: AuthStorageService,
    private userService: UserService,
    private addressService: AddressService,
    private modalController: ModalController,
  ) {
  }

  init() {
    this.authService.LoggedIn.subscribe(async () => this.check());
  }

  async check() {
    if (this.checking) {
      return;
    }
    this.checking = true;
    try {
      if (await this.authStorageService.isChip()
        || await this.authStorageService.isTerminal()) {
        return;
      }
      const [user, addresses] = await Promise.all([
        this.userService.get(),
        this.addressService.getAll()
      ]);
      if (user?.IsGuest || await this.authStorageService.isGuest()) {
        return;
      }
      if (!this.userService.isComplete(user) || !addresses?.length) {
        await this.openProfileCompletionModal();
      }
    } finally {
      this.checking = false;
    }
  }

  private async openProfileCompletionModal() {
    const modal = await this.modalController.create({
      component: ProfileCompletionModalPage,
      cssClass: 'height-90',
      backdropDismiss: false,
    });
    await modal.present();
    await modal.onDidDismiss();
  }
}
